import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from '../../providers/TranslationProvider';
import Button from '../Button';
import { CONSTANTS, getPriorityNotifyButtonVariant, NOOP } from './notifyUtils';

const NotifyPostStateCta = (props) => {
  const {
    closeModalAndReload,
    isGda,
    isPriorityNotify,
    isPriorityExperimentActive,
    isPriorityNotifyAutoEnabled,
    notifyFlowState,
    showAvailability,
    doneLabel,
  } = props;
  const {
    SET_NOTIFY_SUCCESS,
    TABLES_AVAILABLE,
    BUTTON_ID_SUCCESS,
    BUTTON_ID_TABLES_AVAILABLE,
  } = CONSTANTS;
  const buttonVariant = getPriorityNotifyButtonVariant({
    isGda,
    isPriorityExperimentActive,
    isPriorityNotify,
    isPriorityNotifyAutoEnabled,
  });
  const flowStateProps = {
    [SET_NOTIFY_SUCCESS]: {
      buttonOnClick: closeModalAndReload,
      buttonText: doneLabel || getTranslation({ translationKey: 'button_done', fallback: 'Done' }),
      buttonTestId: BUTTON_ID_SUCCESS,
    },
    [TABLES_AVAILABLE]: {
      buttonOnClick: showAvailability,
      buttonText: getTranslation({ translationKey: 'view_now', fallback: 'View Now' }),
      buttonTestId: BUTTON_ID_TABLES_AVAILABLE,
    },
  };
  const { buttonOnClick, buttonText, buttonTestId } = flowStateProps[notifyFlowState];
  return (
    <div className="Notify__cta">
      <Button
        aria-label={buttonText}
        className="Notify__confirm"
        onClick={buttonOnClick}
        variant={buttonVariant}
        data-test-id={buttonTestId}
        lg
      >
        {buttonText}
      </Button>
    </div>
  );
};

NotifyPostStateCta.propTypes = {
  closeModalAndReload: PropTypes.func,
  isGda: PropTypes.bool,
  isPriorityNotify: PropTypes.bool,
  isPriorityExperimentActive: PropTypes.bool,
  isPriorityNotifyAutoEnabled: PropTypes.bool,
  notifyFlowState: PropTypes.string.isRequired,
  showAvailability: PropTypes.func,
  doneLabel: PropTypes.string,
};

NotifyPostStateCta.defaultProps = {
  closeModalAndReload: NOOP,
  isGda: undefined,
  isPriorityNotify: false,
  isPriorityExperimentActive: false,
  isPriorityNotifyAutoEnabled: false,
  showAvailability: NOOP,
  doneLabel: undefined,
};

export default NotifyPostStateCta;
